/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VerifyEmailRouteImport } from './routes/verify-email'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SignupIndexRouteImport } from './routes/signup/index'
import { Route as MfaIndexRouteImport } from './routes/mfa/index'
import { Route as LoginIndexRouteImport } from './routes/login/index'
import { Route as AppSelectIndexRouteImport } from './routes/app-select/index'
import { Route as MfaValidateRouteImport } from './routes/mfa/validate'
import { Route as MfaSetupRouteImport } from './routes/mfa/setup'
import { Route as redirectsResetConfirmRouteImport } from './routes/(redirects)/reset-confirm'
import { Route as redirectsRegisterRouteImport } from './routes/(redirects)/register'
import { Route as PasswordResetIndexRouteImport } from './routes/password/reset/index'
import { Route as PasswordChangeIndexRouteImport } from './routes/password/change/index'
import { Route as PasswordResetSetNewPasswordRouteImport } from './routes/password/reset/set-new-password'

const VerifyEmailRoute = VerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupIndexRoute = SignupIndexRouteImport.update({
  id: '/signup/',
  path: '/signup/',
  getParentRoute: () => rootRouteImport,
} as any)
const MfaIndexRoute = MfaIndexRouteImport.update({
  id: '/mfa/',
  path: '/mfa/',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginIndexRoute = LoginIndexRouteImport.update({
  id: '/login/',
  path: '/login/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppSelectIndexRoute = AppSelectIndexRouteImport.update({
  id: '/app-select/',
  path: '/app-select/',
  getParentRoute: () => rootRouteImport,
} as any)
const MfaValidateRoute = MfaValidateRouteImport.update({
  id: '/mfa/validate',
  path: '/mfa/validate',
  getParentRoute: () => rootRouteImport,
} as any)
const MfaSetupRoute = MfaSetupRouteImport.update({
  id: '/mfa/setup',
  path: '/mfa/setup',
  getParentRoute: () => rootRouteImport,
} as any)
const redirectsResetConfirmRoute = redirectsResetConfirmRouteImport.update({
  id: '/(redirects)/reset-confirm',
  path: '/reset-confirm',
  getParentRoute: () => rootRouteImport,
} as any)
const redirectsRegisterRoute = redirectsRegisterRouteImport.update({
  id: '/(redirects)/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const PasswordResetIndexRoute = PasswordResetIndexRouteImport.update({
  id: '/password/reset/',
  path: '/password/reset/',
  getParentRoute: () => rootRouteImport,
} as any)
const PasswordChangeIndexRoute = PasswordChangeIndexRouteImport.update({
  id: '/password/change/',
  path: '/password/change/',
  getParentRoute: () => rootRouteImport,
} as any)
const PasswordResetSetNewPasswordRoute =
  PasswordResetSetNewPasswordRouteImport.update({
    id: '/password/reset/set-new-password',
    path: '/password/reset/set-new-password',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/verify-email': typeof VerifyEmailRoute
  '/register': typeof redirectsRegisterRoute
  '/reset-confirm': typeof redirectsResetConfirmRoute
  '/mfa/setup': typeof MfaSetupRoute
  '/mfa/validate': typeof MfaValidateRoute
  '/app-select': typeof AppSelectIndexRoute
  '/login': typeof LoginIndexRoute
  '/mfa': typeof MfaIndexRoute
  '/signup': typeof SignupIndexRoute
  '/password/reset/set-new-password': typeof PasswordResetSetNewPasswordRoute
  '/password/change': typeof PasswordChangeIndexRoute
  '/password/reset': typeof PasswordResetIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/verify-email': typeof VerifyEmailRoute
  '/register': typeof redirectsRegisterRoute
  '/reset-confirm': typeof redirectsResetConfirmRoute
  '/mfa/setup': typeof MfaSetupRoute
  '/mfa/validate': typeof MfaValidateRoute
  '/app-select': typeof AppSelectIndexRoute
  '/login': typeof LoginIndexRoute
  '/mfa': typeof MfaIndexRoute
  '/signup': typeof SignupIndexRoute
  '/password/reset/set-new-password': typeof PasswordResetSetNewPasswordRoute
  '/password/change': typeof PasswordChangeIndexRoute
  '/password/reset': typeof PasswordResetIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/verify-email': typeof VerifyEmailRoute
  '/(redirects)/register': typeof redirectsRegisterRoute
  '/(redirects)/reset-confirm': typeof redirectsResetConfirmRoute
  '/mfa/setup': typeof MfaSetupRoute
  '/mfa/validate': typeof MfaValidateRoute
  '/app-select/': typeof AppSelectIndexRoute
  '/login/': typeof LoginIndexRoute
  '/mfa/': typeof MfaIndexRoute
  '/signup/': typeof SignupIndexRoute
  '/password/reset/set-new-password': typeof PasswordResetSetNewPasswordRoute
  '/password/change/': typeof PasswordChangeIndexRoute
  '/password/reset/': typeof PasswordResetIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/verify-email'
    | '/register'
    | '/reset-confirm'
    | '/mfa/setup'
    | '/mfa/validate'
    | '/app-select'
    | '/login'
    | '/mfa'
    | '/signup'
    | '/password/reset/set-new-password'
    | '/password/change'
    | '/password/reset'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/verify-email'
    | '/register'
    | '/reset-confirm'
    | '/mfa/setup'
    | '/mfa/validate'
    | '/app-select'
    | '/login'
    | '/mfa'
    | '/signup'
    | '/password/reset/set-new-password'
    | '/password/change'
    | '/password/reset'
  id:
    | '__root__'
    | '/'
    | '/verify-email'
    | '/(redirects)/register'
    | '/(redirects)/reset-confirm'
    | '/mfa/setup'
    | '/mfa/validate'
    | '/app-select/'
    | '/login/'
    | '/mfa/'
    | '/signup/'
    | '/password/reset/set-new-password'
    | '/password/change/'
    | '/password/reset/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  VerifyEmailRoute: typeof VerifyEmailRoute
  redirectsRegisterRoute: typeof redirectsRegisterRoute
  redirectsResetConfirmRoute: typeof redirectsResetConfirmRoute
  MfaSetupRoute: typeof MfaSetupRoute
  MfaValidateRoute: typeof MfaValidateRoute
  AppSelectIndexRoute: typeof AppSelectIndexRoute
  LoginIndexRoute: typeof LoginIndexRoute
  MfaIndexRoute: typeof MfaIndexRoute
  SignupIndexRoute: typeof SignupIndexRoute
  PasswordResetSetNewPasswordRoute: typeof PasswordResetSetNewPasswordRoute
  PasswordChangeIndexRoute: typeof PasswordChangeIndexRoute
  PasswordResetIndexRoute: typeof PasswordResetIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/verify-email': {
      id: '/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof VerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup/': {
      id: '/signup/'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mfa/': {
      id: '/mfa/'
      path: '/mfa'
      fullPath: '/mfa'
      preLoaderRoute: typeof MfaIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login/': {
      id: '/login/'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app-select/': {
      id: '/app-select/'
      path: '/app-select'
      fullPath: '/app-select'
      preLoaderRoute: typeof AppSelectIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mfa/validate': {
      id: '/mfa/validate'
      path: '/mfa/validate'
      fullPath: '/mfa/validate'
      preLoaderRoute: typeof MfaValidateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mfa/setup': {
      id: '/mfa/setup'
      path: '/mfa/setup'
      fullPath: '/mfa/setup'
      preLoaderRoute: typeof MfaSetupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(redirects)/reset-confirm': {
      id: '/(redirects)/reset-confirm'
      path: '/reset-confirm'
      fullPath: '/reset-confirm'
      preLoaderRoute: typeof redirectsResetConfirmRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(redirects)/register': {
      id: '/(redirects)/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof redirectsRegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/password/reset/': {
      id: '/password/reset/'
      path: '/password/reset'
      fullPath: '/password/reset'
      preLoaderRoute: typeof PasswordResetIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/password/change/': {
      id: '/password/change/'
      path: '/password/change'
      fullPath: '/password/change'
      preLoaderRoute: typeof PasswordChangeIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/password/reset/set-new-password': {
      id: '/password/reset/set-new-password'
      path: '/password/reset/set-new-password'
      fullPath: '/password/reset/set-new-password'
      preLoaderRoute: typeof PasswordResetSetNewPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  VerifyEmailRoute: VerifyEmailRoute,
  redirectsRegisterRoute: redirectsRegisterRoute,
  redirectsResetConfirmRoute: redirectsResetConfirmRoute,
  MfaSetupRoute: MfaSetupRoute,
  MfaValidateRoute: MfaValidateRoute,
  AppSelectIndexRoute: AppSelectIndexRoute,
  LoginIndexRoute: LoginIndexRoute,
  MfaIndexRoute: MfaIndexRoute,
  SignupIndexRoute: SignupIndexRoute,
  PasswordResetSetNewPasswordRoute: PasswordResetSetNewPasswordRoute,
  PasswordChangeIndexRoute: PasswordChangeIndexRoute,
  PasswordResetIndexRoute: PasswordResetIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
